export { default } from './PageInfoPages.vue'
